
require.register("react-bootstrap/lib/utils/createSelectedEvent.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "react-bootstrap");
  (function() {
    "use strict";

exports.__esModule = true;
exports["default"] = createSelectedEvent;

function createSelectedEvent(eventKey) {
  var selectionPrevented = false;

  return {
    eventKey: eventKey,

    preventSelection: function preventSelection() {
      selectionPrevented = true;
    },

    isSelectionPrevented: function isSelectionPrevented() {
      return selectionPrevented;
    }
  };
}

module.exports = exports["default"];
  })();
});